import { useState } from "react";
import { Group, Box, Collapse, ThemeIcon, rem } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import classes from "../css/NavbarLinksGroup.module.css";

function LinksGroup({ icon: Icon, label, initiallyOpened, links, isratp }) {
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(initiallyOpened || false);
  const items = (hasLinks ? links.filter((link) => !!link.link) : []).map((link) => (
    <a className={classes.link} href={link.link} key={link.label}>
      <Group>{link.label}</Group>
    </a>
  ));

  return (
    <>
      <a onClick={() => setOpened((o) => !o)} className={classes.control}>
        <Group justify="space-between" gap={0}>
          <Box style={{ display: "flex", alignItems: "center" }}>
            <ThemeIcon style={{ color: isratp ? "#0a0082" : "#ff7e2e" }} variant="light" size={30}>
              <Icon style={{ width: rem(22), height: rem(22) }} />
            </ThemeIcon>
            <Box ml="md">{label}</Box>
          </Box>
          {hasLinks && (
            <IconChevronRight
              className={classes.chevron}
              stroke={1.5}
              style={{
                width: rem(16),
                height: rem(16),
                transform: opened ? "rotate(-90deg)" : "none",
              }}
            />
          )}
        </Group>
      </a>
      {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
    </>
  );
}

export { LinksGroup };
